import React from "react";
import Link from "next/link";
import { withImageResizer } from "lib/utils";
import LocationIcon from "../Icons/LocationIcon";
import ArrowRight from "../Icons/ArrowRight";

const ChurchCarouselItem = ({
  position,
  itemData,
  idx,
  isChurchpage = false,
  gridMode = false,
}) => {
  const createItem = ({ position, itemData, idx }) => {
    const item = {
      styles: {},
      data: itemData,
    };
    switch (position) {
      case position - 1:
      case position + 1:
        item.styles = {
          ...item.styles,
        };
        break;
      case position:
        break;
      default:
        item.styles = { ...item.styles, ...{ display: "none" } };
        break;
    }
    return item;
  };
  const {
    data: { title, account, descriptionParsed, styles, images },
  } = createItem({ position, itemData, idx });
  return (
    <>
      <Link
        href={`/?churchSlug=${account.urlName}`}
        as={`/kirkko/${account.urlName}`}
      >
        <a
          className={`group block mx-1 hover:first:ml-[13px] hover:first:mr-[-13px] transition-all duration-200 ease-linear delay ${
            isChurchpage && "flex-1"
          } ${gridMode ? "max-w-[255px] mr-[18px] min-w-[255px] ml-0" : ""}`}
        >
          <li
            style={{ ...styles }}
            className={`rounded-10 w-full transition-all duration-200 ease-linear delay group-hover:scale-110 group-hover:shadow-item pb-5 group-hover:pb-0 min-w-[180px] ${
              isChurchpage ? "min-w-full" : ""
            }`}
          >
            <img
              alt={"kuva " + account.name}
              className={`bg-gray-100 rounded-10 w-full h-383 desktop:!h-[320px] object-cover object-bottom transition-all duration-300 ease-linear delay group-hover:rounded-br-none  group-hover:rounded-bl-none `}
              src={
                images?.background
                  ? withImageResizer(images?.background, 640)
                  : "/images/church-icon.png"
              }
            />
            <article className="rounded-lg bg-white-100 transition-all duration-200 ease-linear delay group-hover:pl-4">
              <h2 className="py-1.5 text-bodyText font-bold bg-white-100 transition-all duration-200 ease-linear delay origin-left group-hover:pt-3 group-hover:scale-95 .truncate-text two-lines">
                {account.name}
              </h2>
              <div className="flex justify-between pb-2 opacity-0 transition-all duration-200 ease-linear delay group-hover:opacity-100">
                {descriptionParsed && descriptionParsed.data?.address && (
                  <div className="">
                    <p className="flex items-center min-h-[55px]">
                      <LocationIcon height={26.7} width={20.03} />
                      <span className="px-2.5 pb-0.5 text-gray text-sm font-bold transition-all duration-200 ease-linear delay origin-left group-hover:scale-95">
                        {descriptionParsed.data.address}
                      </span>
                    </p>
                  </div>
                )}
                <div className="flex items-center transition-all duration-200 ease-linear delay">
                  <div className="rounded bg-blue flex justify-center items-center self-center w-7 h-27 mr-5">
                    <div className="flex justify-center rounded bg-blue self-center text-lg font-bold text-white">
                      <ArrowRight height={10} width={6} />
                    </div>
                  </div>
                </div>
              </div>
            </article>
          </li>
        </a>
      </Link>
    </>
  );
};

export default ChurchCarouselItem;
